import Swal from 'sweetalert2'

export function AlertSuccess(title, msg) {
  Swal.fire({
    title: title,
    html: msg,
    icon: 'success',
    confirmButtonText: ' ปิด ',
    cancelButtonText: 'ยกเลิก',
    showCancelButton: false,
    buttonsStyling: false,
    customClass: {
      confirmButton: 'btn-orange-alert',
      // cancelButton: 'btn btn-danger'
    }
  })
}

export const AlertError = () => {
  return Swal.fire({
    confirmButtonText: "ปิด",
    icon: "error",
    title: "ขออภัย",
    text: "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง",
    showCancelButton: false,
    buttonsStyling: false,
    customClass: {
      confirmButton: 'btn-orange-alert',
      // cancelButton: 'btn btn-danger'
    }
  });
};

export const AlertWarning = (title, msg) => {
  return Swal.fire({
    confirmButtonText: "ปิด",
    icon: "warning",
    title: title,
    html: msg,
    showCancelButton: false,
    buttonsStyling: false,
    customClass: {
      confirmButton: 'btn-orange-alert',
      // cancelButton: 'btn btn-danger'
    }
  });
};

export const AlertInfo = (title, msg) => {
  return Swal.fire({
    confirmButtonText: "ปิด",
    icon: "info",
    title: title,
    html: msg,
    showCancelButton: false,
    buttonsStyling: false,
    customClass: {
      confirmButton: 'btn-orange-alert',
      // cancelButton: 'btn btn-danger'
    }
  });
};

export function Loading(title, msg) {
  Swal.fire({
    title: title ? title : '',
    html: msg ? msg : '',
    timerProgressBar: true,
    allowOutsideClick: false,
    // background: 'rgba(0, 0, 0, 0.0)',
    customClass: 'swal-loading-wide',

    backdrop: `
      rgba(0,0,0,0.4)
      left top
      no-repeat
    `,
    didOpen: () => {
      Swal.showLoading();
    },
  });
}

export const AlertClose = () => {
  Swal.close();
};


